document.addEventListener('DOMContentLoaded', () => {
	const engravingText = document.querySelector('.engraving-image__text');
	const engravingBox = document.querySelector('.engraving-image__box');
	const engravingInput = document.getElementById('engraving-actions__text-input');
	const formEngravingTrue = document.querySelector(".variant-picker__option input[value='Personalised']");
	const formEngravingFalse = document.querySelector(".variant-picker__option input[value='Generic']");
	const productHandle = document.querySelector('.trigger-personalisation').dataset.productHandle;
	const engravingImage = document.querySelector('.engraving-content__image .cup');
	const engravingButton = document.querySelector('.add-engraving');
	const removeEngravingButton = document.querySelector('.remove-personalisation');
	const imageInput = document.getElementById('engraving-actions__file');
	const previewImage = document.getElementById('engraving-image__preview');
	const previewCanvas = document.getElementById('engraving-image__canvas');
	const rotateButton = document.querySelector('.engraving-actions__file-rotate');
	const colourVariants = document.querySelectorAll('variant-radios .product-form__input')[0];
	const sizeVariants = document.querySelectorAll('variant-radios .product-form__input')[1];
	const buttonZoomIn = document.querySelector('.engraving-actions__zoom-in');
	const buttonZoomOut = document.querySelector('.engraving-actions__zoom-out');
	const canvasTopl = document.getElementById('captureTopl');
	const modalPersonalisation = document.querySelector('.product-engraving');
	const header = document.querySelector('header');
	const buttonAddToCart = document.querySelector('buy-buttons button[type="submit"]');
	const buttonTriggerPersonalisation = document.querySelector('.trigger-personalisation');
	const personalisationInfo = document.querySelector('.personalisation-info');
	const variantInputs = document.querySelectorAll('.vm-prod-input');
	const triggerPersonalisation = document.querySelector('.trigger-personalisation');
	const errorInput = document.querySelector('.engraving-actions__error-input');
	const personalisationInfoContainer = document.querySelector('.personalisation-info');
	const stepsPhone = document.querySelector('.actions-selector__steps');
	const quantityInputPersonalisationDrawer = document.querySelector('.engraving-actions__quantity-selector .quantity-selector input');
	const quantityInputProductPage = document.querySelector('.product-info__quantity-selector .quantity-selector input');
	const body = document.querySelector('body');
	const productDescription = document.querySelector('.product-info__description');
	let pageScrollTop = 0;
	const cloud = new cloudinary.Cloudinary({
		cloud_name: 'ddtdpb7gx',
		secure: true,
	});

	const errorContainer = document.querySelector('.product-personalisation__error');
	const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/ddtdpb7gx/upload`;
	const CLOUDINARY_UPLOAD_PRESET = 'CobrandedCupPersonalisation';
	const METAL_TEXTURE_URL =
		'https://cdn.shopify.com/s/files/1/0950/9486/6259/files/silver-metallic-textured-background_dcebf7cb-b1a5-4436-83f2-2c93ce06deeb.jpg?v=1759393642';
	const errorSpecialsCharacters = document.querySelector('.error-special-characters');

	window.currentProductPersonalisation = window.currentProductPersonalisation || {};
	window.currentProductPersonalisation.enabled = false;
	window.currentProductPersonalisation.product = '';
	window.currentProductPersonalisation.variant = '';
	window.currentProductPersonalisation.position = 'Logo Center';
	window.currentProductPersonalisation.style = 'Bold';
	window.currentProductPersonalisation.scale = 1;
	window.currentProductPersonalisation.imageName = '';
	window.currentProductPersonalisation.imageUrl = '';
	window.currentProductPersonalisation.imageNameMug = '';
	window.currentProductPersonalisation.imageUrlMug = '';
	window.currentProductPersonalisation.rotation = 0;
	window.currentProductPersonalisation.text = '';
	window.currentProductPersonalisation.personalisationAdded = false;
	window.currentProductPersonalisation.multipleNames = false;

	const isLogoAndTextSelected = () => window.currentProductPersonalisation.position === 'Logo & Text';

	const isBoldStyleSelected = () => {
		const currentStyle = window.currentProductPersonalisation.style;

		return currentStyle === 'Bold' || currentStyle === 'adam';
	};

	const shouldUseUppercaseText = () => isLogoAndTextSelected() && isBoldStyleSelected();

	triggerPersonalisation.innerHTML = triggerPersonalisation.dataset.initialLabel;

	const getNormalMinimumQuantity = () => {
		const drawerMinimum = Number(quantityInputPersonalisationDrawer?.dataset.normal);

		if (drawerMinimum > 0) return drawerMinimum;

		const pageMinimum = Number(quantityInputProductPage?.dataset.normal);

		if (pageMinimum > 0) return pageMinimum;

		return 1;
	};

	const getCobrandedMinimumQuantity = () => {
		const drawerMinimum = Number(quantityInputPersonalisationDrawer?.dataset.cobranded);

		if (drawerMinimum > 0) return drawerMinimum;

		const pageMinimum = Number(quantityInputProductPage?.dataset.cobranded);

		if (pageMinimum > 0) return pageMinimum;

		return getNormalMinimumQuantity();
	};

	const syncProductPageQuantity = (quantity) => {
		if (!quantityInputProductPage) return;

		if ('quantity' in quantityInputProductPage) {
			quantityInputProductPage.quantity = quantity;
		} else {
			quantityInputProductPage.value = quantity;
		}

		quantityInputProductPage.min = quantity;
		quantityInputProductPage.dispatchEvent(new Event('input', { bubbles: true }));
		quantityInputProductPage.dispatchEvent(new Event('change', { bubbles: true }));
	};

	const setDrawerMinimumQuantity = (minimumQuantity, forceQuantity = false) => {
		if (!quantityInputPersonalisationDrawer) return;

		quantityInputPersonalisationDrawer.dataset.min = minimumQuantity;
		quantityInputPersonalisationDrawer.min = minimumQuantity;

		const currentQuantity = Number(quantityInputPersonalisationDrawer.value);
		if (forceQuantity || currentQuantity < minimumQuantity) {
			if ('quantity' in quantityInputPersonalisationDrawer) {
				quantityInputPersonalisationDrawer.quantity = minimumQuantity;
			} else {
				quantityInputPersonalisationDrawer.value = minimumQuantity;
			}
		}

		quantityInputPersonalisationDrawer.dispatchEvent(new Event('input', { bubbles: true }));
		quantityInputPersonalisationDrawer.dispatchEvent(new Event('change', { bubbles: true }));
	};

	const applyMinimumQuantityByDesignType = (designType) => {
		const minimumQuantity = designType === 'printed' ? getCobrandedMinimumQuantity() : getNormalMinimumQuantity();

		setDrawerMinimumQuantity(minimumQuantity, true);
		syncProductPageQuantity(Number(quantityInputPersonalisationDrawer?.value || minimumQuantity));
	};

	const lockBodyScroll = () => {
		pageScrollTop = window.scrollY;

		document.body.classList.add('product-engraving-open');
		document.body.style.position = 'fixed';
		document.body.style.top = `-${pageScrollTop}px`;
		document.body.style.left = '0';
		document.body.style.right = '0';
		document.body.style.width = '100%';
	};

	const unlockBodyScroll = () => {
		document.body.classList.remove('product-engraving-open');
		document.body.style.position = '';
		document.body.style.top = '';
		document.body.style.left = '';
		document.body.style.right = '';
		document.body.style.width = '';

		window.scrollTo(0, pageScrollTop);
	};

	const rotateImage = () => {
		const currentZoom = currentProductPersonalisation.scale;
		const currentRotation = currentProductPersonalisation.rotation;
		let nextRotation = currentRotation + 90;

		if (nextRotation === 360) nextRotation = 0;

		document.querySelector('#engraving-image__canvas').style.transform = `rotate(${nextRotation}deg) scale(${currentZoom.toFixed(2)})`;

		currentProductPersonalisation.rotation = nextRotation;
	};

	buttonZoomIn.addEventListener('click', () => {
		zoom('+');
	});

	buttonZoomOut.addEventListener('click', () => {
		zoom('-');
	});

	document.getElementById('engraving-actions__file-rotate').addEventListener('click', () => {
		rotateImage();
	});

	document.addEventListener('variant:change', () => {
		changeImagePersonalisation();

		// Update inventory and check stock levels
		const inventoryWrapperInModal = document.querySelector('.product-engraving .inventory-wrapper');
		const inventoryWrapperOnPage = document.querySelector('.product-form .inventory-wrapper');

		// If we have an inventory wrapper in the modal and one on the page, copy the data
		if (inventoryWrapperInModal && inventoryWrapperOnPage) {
			const variantStock = inventoryWrapperOnPage.getAttribute('data-variant-stock');
			inventoryWrapperInModal.setAttribute('data-variant-stock', variantStock);

			// Re-check stock levels against quantity
			disablePersonalisationBasedOnStock();
		}
	});

	//hide personalisation info if change variant
	variantInputs.forEach((input) => {
		input.addEventListener('click', () => {
			if (personalisationInfo.style.display === 'block') {
				personalisationInfo.style.display = 'none';
			}
		});
	});

	const disablePersonalisationBasedOnStock = () => {
		if (buttonAddToCart.innerHTML.includes('Sold out')) {
			engravingButton.innerHTML = 'Out of stock';
			engravingButton.disabled = true;
			triggerPersonalisation.innerHTML = triggerPersonalisation.dataset.labelOutOfStock;
		} else {
			engravingButton.innerHTML = 'Add to Cart';
			triggerPersonalisation.innerHTML = triggerPersonalisation.dataset.initialLabel;

			// Get the current stock and quantity
			const inventoryWrapper = document.querySelector('.inventory-wrapper');
			const quantityInput = document.querySelector('.engraving-actions__quantity-selector .quantity-selector input');

			if (inventoryWrapper && quantityInput) {
				const currentStock = parseInt(inventoryWrapper.getAttribute('data-variant-stock') || 0);
				const requestedQuantity = parseInt(quantityInput.value || 0);

				// Disable button if quantity exceeds stock
				if (requestedQuantity > currentStock) {
					engravingButton.disabled = true;
					engravingButton.innerHTML = 'Insufficient stock';
				} else if (!imageInput.files[0] || Math.round(imageInput.files[0].size / 1024 >= 3072)) {
					engravingButton.disabled = true;
				} else {
					engravingButton.disabled = false;
				}
			} else if (!imageInput.files[0] || Math.round(imageInput.files[0].size / 1024 >= 3072)) {
				engravingButton.disabled = true;
			} else {
				engravingButton.disabled = false;
			}
		}
	};

	disablePersonalisationBasedOnStock();

	// Add event listener to quantity input to check stock when quantity changes
	const quantityInput = document.querySelector('.engraving-actions__quantity-selector .quantity-selector input');
	if (quantityInput) {
		const quantityButtons = document.querySelectorAll('.engraving-actions__quantity-selector .quantity-selector__button');

		// Listen for direct input changes
		quantityInput.addEventListener('change', disablePersonalisationBasedOnStock);
		quantityInput.addEventListener('input', disablePersonalisationBasedOnStock);

		// Listen for button clicks
		quantityButtons.forEach((button) => {
			button.addEventListener('click', () => {
				setTimeout(disablePersonalisationBasedOnStock, 100);
			});
		});
	}

	const initializeQuantityInput = () => {
		const quantityInputPersonalisationDrawer = document.querySelector('.engraving-actions__quantity-selector .quantity-selector input');

		if (quantityInputPersonalisationDrawer) {
			quantityInputPersonalisationDrawer.min = quantityInputPersonalisationDrawer.dataset.min;

			if ('quantity' in quantityInputPersonalisationDrawer) {
				quantityInputPersonalisationDrawer.quantity = quantityInputPersonalisationDrawer.dataset.min;
			} else {
				quantityInputPersonalisationDrawer.value = quantityInputPersonalisationDrawer.dataset.min;
			}

			quantityInputPersonalisationDrawer.dispatchEvent(new Event('input', { bubbles: true }));
			quantityInputPersonalisationDrawer.dispatchEvent(new Event('change', { bubbles: true }));
		}

		//quantityInputProductPage.min = quantityInputProductPage.dataset.min;
		// if (quantityInputProductPage.value < quantityInputProductPage.dataset.min) {
		// 	quantityInputProductPage.value = quantityInputProductPage.dataset.min;
		// }

		// quantityInputPersonalisationDrawer.value = quantityInputProductPage.value;
	};

	const resetQuantityInput = () => {
		if (quantityInputProductPage) {
			quantityInputProductPage.min = 1;

			if ('quantity' in quantityInputProductPage) {
				quantityInputProductPage.quantity = 1;
			} else {
				quantityInputProductPage.value = 1;
			}

			quantityInputProductPage.dispatchEvent(new Event('input', { bubbles: true }));
			quantityInputProductPage.dispatchEvent(new Event('change', { bubbles: true }));
		}

		if (quantityInputPersonalisationDrawer) {
			quantityInputPersonalisationDrawer.min = 1;
			quantityInputPersonalisationDrawer.dataset.min = 1;

			if ('quantity' in quantityInputPersonalisationDrawer) {
				quantityInputPersonalisationDrawer.quantity = 1;
			} else {
				quantityInputPersonalisationDrawer.value = 1;
			}

			quantityInputPersonalisationDrawer.dispatchEvent(new Event('input', { bubbles: true }));
			quantityInputPersonalisationDrawer.dispatchEvent(new Event('change', { bubbles: true }));
		}
	};

	//disable add persoanlisation based on stock
	buttonAddToCart.addEventListener('DOMSubtreeModified', function () {
		disablePersonalisationBasedOnStock();
	});

	imageInput.addEventListener('change', async (el) => {
		const [image] = el.target.files;

		await updateCupBasedOnImage(image, el.target);
	});

	async function updateCupBasedOnImage(image, imageInputElement) {
		if (image) {
			const canvasImage = new SimpleImage(imageInputElement);

			if (Math.round(image.size / 1024) >= 3072) {
				errorInput.style.display = 'block';
			} else {
				errorInput.style.display = 'none';

				const designType = document.querySelector('.engraving-actions__selector--design-type li.is-selected').dataset.type;

				disablePersonalisationBasedOnStock();
				canvasImage.drawTo(previewCanvas);

				if (designType === 'engraving') {
					// Load the metal texture for engraving
					const metalTexture = await loadMetalTexture(
						'https://cdn.shopify.com/s/files/1/0950/9486/6259/files/silver-metallic-textured-background_dcebf7cb-b1a5-4436-83f2-2c93ce06deeb.jpg?v=1759393642'
					);

					setTimeout(() => {
						const ctx = previewCanvas.getContext('2d');
						const imageData = ctx.getImageData(0, 0, previewCanvas.width, previewCanvas.height);
						const data = imageData.data;

						for (let y = 0; y < previewCanvas.height; y++) {
							for (let x = 0; x < previewCanvas.width; x++) {
								const i = (y * previewCanvas.width + x) * 4;

								// Only process non-transparent pixels (Alpha > 0)
								if (data[i + 3] > 0) {
									const metalPixel = getPixelFromTexture(metalTexture, x, y);

									// FULL REPLACEMENT with metal texture
									data[i] = metalPixel.r; // Red
									data[i + 1] = metalPixel.g; // Green
									data[i + 2] = metalPixel.b; // Blue
								}
							}
						}

						ctx.putImageData(imageData, 0, 0);
					}, 100);
				}
			}
		}
	}

	async function loadMetalTexture(url) {
		return new Promise((resolve) => {
			const img = new Image();
			img.crossOrigin = 'Anonymous'; // Allows cross-origin image use
			img.src = url;
			img.onload = () => {
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');

				canvas.width = img.width;
				canvas.height = img.height;
				ctx.drawImage(img, 0, 0);

				resolve(ctx.getImageData(0, 0, canvas.width, canvas.height));
			};
		});
	}

	function getPixelFromTexture(texture, x, y) {
		const textureWidth = texture.width;
		const textureHeight = texture.height;
		const canvasWidth = previewCanvas.width;
		const canvasHeight = previewCanvas.height;

		// Scale coordinates to fit within the texture
		const textureX = Math.floor((x / canvasWidth) * textureWidth);
		const textureY = Math.floor((y / canvasHeight) * textureHeight);

		const index = (textureY * textureWidth + textureX) * 4;
		return {
			r: texture.data[index],
			g: texture.data[index + 1],
			b: texture.data[index + 2],
		};
	}

	const changeImagePersonalisation = () => {
		const selectedColour = document.querySelector('.variant-picker__option-colour input:checked').value;
		const selectedSize = document.querySelector('.variant-picker__option-size input:checked').value;

		const selectedImageURL = variantImage[`${selectedColour} / ${selectedSize} / Personalised`];
		engravingImage.style.backgroundImage = `url(${selectedImageURL})`;

		const selectedVariantSize = variantSize[`${selectedColour} / ${selectedSize} / Personalised`];

		// Remove all possible size classes before adding the new one
		[...new Set(Object.values(variantSize))].forEach((size) => {
			engravingBox.classList.remove(`engraving-image__box--cup-${size}`);
		});

		engravingBox.classList.add(`engraving-image__box--cup-${selectedVariantSize}`);
	};

	const openModal = () => {
		modalPersonalisation.classList.add('product-engraving--visible');
		lockBodyScroll();
		header.style.display = 'none';
		personalisationInfo.style.display = 'none';

		disablePersonalisationBasedOnStock();
	};

	const closeModal = () => {
		modalPersonalisation.classList.remove('product-engraving--visible');
		unlockBodyScroll();
		header.style.display = 'block';
		selectVariantWithoutPersonalisation();
		resetQuantityInput();
	};

	const resetErrorContainer = () => {
		errorContainer.innerHTML = '';
		errorContainer.style.display = 'none';
	};

	//Trigger personalisation
	buttonTriggerPersonalisation.addEventListener('click', () => {
		backToFirstStepIfPhone();

		initializeQuantityInput();
		resetErrorContainer();
		changeImagePersonalisation();
		openModal();
	});

	const rerenderCart = async (responseJson) => {
		let sectionsToBundle = ['variant-added'];
		document.documentElement.dispatchEvent(
			new CustomEvent('cart:prepare-bundled-sections', {
				bubbles: true,
				detail: { sections: sectionsToBundle },
			})
		);

		responseJson.sections = sectionsToBundle.join(',');
		const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
		cartContent['sections'] = responseJson['sections'];

		let config = {
			bubbles: true,
		};
		if (window.currentProductPersonalisation.multipleNames === true) {
			config.detail = {
				openNote: true,
			};
		}

		document.documentElement.dispatchEvent(
			new CustomEvent('cart:change', {
				bubbles: true,
				detail: {
					baseEvent: 'variant:add',
					cart: cartContent,
				},
			})
		);

		document.documentElement.dispatchEvent(
			new CustomEvent('cart:refresh', {
				bubbles: true,
			})
		);

		document.documentElement.dispatchEvent(new CustomEvent('cart:show', config));
	};

	const selectVariantWithPersonalisation = () => {
		formEngravingTrue.click();
		formEngravingFalse.checked = false;
	};

	const selectVariantWithoutPersonalisation = () => {
		formEngravingFalse.click();
		formEngravingTrue.checked = false;
	};

	//Add engraving to cart
	engravingButton.addEventListener('click', async () => {
		selectVariantWithPersonalisation();
		const infoTextContent = document.querySelector('.personalisation-info__text');
		const infoImageName = document.querySelector('.personalisation-info__image');

		engravingButton.classList.add('button--loading');
		engravingButton.disabled = true;

		window.scrollTo(0, 0);

		let restoreCaptureDom = null;

		try {
			await document.fonts.ready;
			restoreCaptureDom = await prepareMockupCaptureDom();

			const canvas = await html2canvas(canvasTopl, {
				useCORS: true,
				allowTaint: false,
				backgroundColor: '#ffffff',
				removeContainer: true,
				imageTimeout: 15000,
				logging: false,
				scale: 2,
			});

			const dataURL = canvas.toDataURL('image/jpeg', 1);
			const blob = dataURItoBlob(dataURL);
			const fileMugImage = new File([blob], 'topl-design.jpeg', {
				type: 'image/jpeg',
			});
			const formDataImageMug = new FormData();

			formDataImageMug.append('file', fileMugImage);
			formDataImageMug.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

			const mugResponse = await axios({
				url: CLOUDINARY_URL,
				method: 'POST',
				data: formDataImageMug,
			});

			currentProductPersonalisation.imageNameMug = fileMugImage.name;
			currentProductPersonalisation.imageUrlMug = mugResponse.data.secure_url;

			currentProductPersonalisation.enabled = true;
			currentProductPersonalisation.text = shouldUseUppercaseText()
				? engravingInput.value.toUpperCase()
				: engravingInput.value;
			infoTextContent.innerHTML = currentProductPersonalisation.text;

			const formDataImage = new FormData();

			formDataImage.append('file', imageInput.files[0]);
			formDataImage.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

			const logoResponse = await axios({
				url: CLOUDINARY_URL,
				method: 'POST',
				data: formDataImage,
			});

			currentProductPersonalisation.imageName = imageInput.files[0].name;
			currentProductPersonalisation.imageUrl = logoResponse.data.secure_url;
			infoImageName.innerHTML = imageInput.files[0].name;

			if (currentProductPersonalisation.text.length > 0 && currentProductPersonalisation.position === 'Logo & Text') {
				document.querySelector('.personalisation-info__text-item').style.display = 'block';
				document.querySelector('.personalisation-info__style-item').style.display = 'block';
			}

			if (currentProductPersonalisation.position !== 'Logo & Text') {
				document.querySelector('.personalisation-info__text-item').style.display = 'none';
				document.querySelector('.personalisation-info__style-item').style.display = 'none';
			}

			const cartData = await prepareToAddToCart();
			const responseJSON = await addPersonalisationToCart(cartData);

			if (responseJSON) {
				rerenderCart(responseJSON);
				closeModal();
			}
		} catch (error) {
			console.error(error);
		} finally {
			if (restoreCaptureDom) restoreCaptureDom();
			engravingButton.classList.remove('button--loading');
			engravingButton.disabled = false;
		}
	});

	const prepareToAddToCart = async () => {
		try {
			const selectedColour = document.querySelector('.variant-picker__option-colour input:checked').value;
			const selectedSize = document.querySelector('.variant-picker__option-size input:checked').value;
			const quantity = document.querySelector('.engraving-actions__quantity-selector .quantity-selector input')?.value || 1;

			const response = await getProductData(productHandle);

			const variantToAddToCart = response.variants.find(
				(variant) => variant.option1 === selectedColour && variant.option2 === selectedSize && variant.option3 === 'Personalised'
			);

			if (!variantToAddToCart) {
				throw new Error('Selected variant not found.');
			}

			const text = window.currentProductPersonalisation.position == 'Logo & Text' ? window.currentProductPersonalisation.text : '';

			const cartData = {
				id: variantToAddToCart.id,
				quantity: Number(quantity),
				properties: {
					position: window.currentProductPersonalisation.position,
					style: window.currentProductPersonalisation.style,
					rotation: window.currentProductPersonalisation.rotation,
					'Image Name': currentProductPersonalisation.imageName,
					'Image URL': currentProductPersonalisation.imageUrl,
					'Mockup URL': currentProductPersonalisation.imageUrlMug,
					'Design Type': window.currentProductPersonalisation.designType,
				},
			};

			if (text !== '') {
				cartData.properties.text = text;
			}
			return cartData;
		} catch (error) {
			console.error(error);
			throw error; // Rethrow the error to be handled by the caller
		}
	};

	const addPersonalisationToCart = async (cartData) => {
		try {
			const response = await fetch('/cart/add.js', {
				body: JSON.stringify(cartData),
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'xmlhttprequest',
				},
				method: 'POST',
			});

			const jsonData = await response.json();

			if (jsonData.message === 'Cart Error' || jsonData.status === 422 || jsonData.status === 404) {
				productDescription.parentNode.insertBefore(errorContainer, productDescription);
				errorContainer.innerHTML = jsonData.description;
				errorContainer.style.display = 'block';

				closeModal();
			} else {
				const cartDataResponse = await getCartData();
				const currentCartEngraving = cartDataResponse.items.find((element) => element.key === jsonData.key);
				const currentCartEngravingIndex = cartDataResponse.items.indexOf(currentCartEngraving);

				removeEngravingButton.dataset.index = currentCartEngravingIndex;
				engravingButton.dataset.index = currentCartEngravingIndex;

				updatePersonalisationInfoBox(currentCartEngraving);
				window.currentProductPersonalisation.personalisationAdded = true;

				// Return the response data
				return jsonData;
			}
		} catch (err) {
			console.error(err);
			throw err; // Rethrow the error to be handled by the caller
		} finally {
			// Remove loading and disabled classes from the button
			engravingButton.classList.remove('button--loading');
			engravingButton.disabled = false;
		}
	};

	//Remove engraving
	removeEngravingButton.addEventListener('click', async () => {
		try {
			removeEngravingButton.classList.add('button--loading', 'disabled');
			formEngravingFalse.click();

			if (window.currentProductPersonalisation.personalisationAdded) {
				const cart = await getCartData();
				const line = cart.items.findIndex((item) => item.key === removeEngravingButton.dataset.variantKey);

				if (line !== -1) {
					await fetch('/cart/change.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify({
							line: line + 1,
							quantity: 0,
							properties: {
								key: removeEngravingButton.dataset.variantKey,
							},
						}),
					});
				}

				removePersonalisationUi();
				const cartDataResponse = await getCartData();
				await rerenderCart(cartDataResponse);
			} else {
				removePersonalisationUi();
			}
		} catch (error) {
			console.error('Error:', error);
		} finally {
			removeEngravingButton.classList.remove('button--loading', 'disabled');
			document.dispatchEvent(
				new CustomEvent('cart-drawer--rebuild', {
					bubbles: false,
				})
			);
		}
	});

	document.querySelector('.engraving-content__back').addEventListener('click', () => {
		closeModal();
	});

	document.querySelectorAll('.engraving-actions__selector > ul > li').forEach((item) => {
		item.addEventListener('click', async () => {
			const infoLogoPosition = document.querySelector('.personalisation-info__position');
			const infoTextStyle = document.querySelector('.personalisation-info__style');

			item.parentElement.querySelectorAll('li').forEach((li) => {
				li.classList.remove('is-selected');
			});

			item.classList.add('is-selected');
			window.currentProductPersonalisation.position = item.dataset.text;

			if (item.classList.contains('set-position')) {
				const textPosition = item.dataset.position;

				const textInputPanel = document.querySelector('.engraving-actions__selector--text-input');
				const fontStylePanel = document.querySelector('.engraving-actions__selector--font-style');

				if (textPosition === 'text') {
					textInputPanel.classList.remove('vm-hidden');
					fontStylePanel.classList.remove('vm-hidden');
					applyMinimumQuantityByDesignType('printed');
				} else {
					textInputPanel.classList.add('vm-hidden');
					fontStylePanel.classList.add('vm-hidden');
					clearStepPanelDisplay(textInputPanel);
					clearStepPanelDisplay(fontStylePanel);
					applyMinimumQuantityByDesignType('engraving');
				}

				backToFirstStepIfPhone();

				// Validate stock against new quantity requirements after position change
				setTimeout(disablePersonalisationBasedOnStock, 100);

				engravingBox.classList.remove('engraving-image__box--center');
				engravingBox.classList.remove('engraving-image__box--bottom');
				engravingBox.classList.remove('engraving-image__box--text');
				engravingBox.classList.add(`engraving-image__box--${item.dataset.position}`);
				infoLogoPosition.innerHTML = item.dataset.text === 'Logo Center' ? 'Logo Center' : 'Logo Bottom';
			}

			if (item.classList.contains('set-style')) {
				engravingBox.classList.remove('engraving-image__box--adam');
				engravingBox.classList.remove('engraving-image__box--modernline');
				engravingBox.classList.add(`engraving-image__box--${item.dataset.style}`);
				updateTextOnCup(engravingInput);
				cloneElement.style.fontFamily = window.getComputedStyle(engravingText).fontFamily;
				infoTextStyle.innerHTML = item.dataset.style === 'modernline' ? 'Handwritten' : 'Bold';
				currentProductPersonalisation.style = item.dataset.style;
			}

			if (item.classList.contains('set-design-type')) {
				engravingBox.classList.remove('engraving-image__box--design-engraving', 'engraving-image__box--design-printed');
				engravingBox.classList.add(`engraving-image__box--design-${item.dataset.type}`);

				if (imageInput.files.length > 0) {
					await updateCupBasedOnImage(imageInput.files[0], imageInput);
				}

				if (item.dataset.type === 'printed') {
					window.currentProductPersonalisation.designType = 'Printed';
					applyMinimumQuantityByDesignType('printed');
				} else {
					window.currentProductPersonalisation.designType = 'Engraving';
					applyMinimumQuantityByDesignType('engraving');
				}

				// Validate stock against new quantity requirements after design type change
				setTimeout(disablePersonalisationBasedOnStock, 100);
			}
		});
	});

	const getAllStepPanels = () =>
		Array.from(
			document.querySelectorAll(
				'.engraving-content__actions > .engraving-actions__selector, .engraving-content__actions > .engraving-actions__finish'
			)
		);

	const getStepPanels = () => getAllStepPanels().filter((panel) => !panel.classList.contains('vm-hidden'));

	const clearStepPanelDisplay = (panel) => {
		if (panel) panel.style.display = '';
	};

	const toggleStepPanel = (currentPanel, direction) => {
		const stepPanels = getStepPanels();
		const currentStepIndex = stepPanels.indexOf(currentPanel);

		if (currentStepIndex < 0) return;

		const nextStepIndex = currentStepIndex + direction;
		const nextStepPanel = stepPanels[nextStepIndex];

		if (!nextStepPanel) return;

		currentPanel.style.display = 'none';
		nextStepPanel.style.display = 'flex';
	};

	document.querySelectorAll('.actions-selector__next').forEach((item, index) => {
		item.addEventListener('click', () => {
			const parent = item.parentElement.parentElement;

			toggleStepPanel(parent, 1);
		});
	});

	document.querySelectorAll('.actions-selector__previous').forEach((item) => {
		item.addEventListener('click', () => {
			const parent = item.parentElement.parentElement;

			toggleStepPanel(parent, -1);
		});
	});

	const cloneElement = document.createElement('div');
	cloneElement.id = 'clone';
	cloneElement.style.position = 'absolute';
	cloneElement.style.transform = 'none';
	cloneElement.style.visibility = 'hidden';
	cloneElement.style.lineHeight = '1';
	cloneElement.style.top = '100px';

	engravingBox.appendChild(cloneElement);

	engravingInput.addEventListener('input', (event) => {
		const textInput = event.target;

		const validPattern = /^[a-zA-Z0-9]*$/;

		if (!validPattern.test(engravingInput.value)) {
			engravingInput.classList.add('error');
			errorSpecialsCharacters.classList.remove('hidden');

			engravingInput.value = engravingInput.value.replace(/[^a-zA-Z0-9]/g, '');

			errorSpecialsCharacters.classList.remove('hidden');
		} else {
			if (!errorSpecialsCharacters.classList.contains('hidden')) {
				errorSpecialsCharacters.classList.add('hidden');
			}

			if (shouldUseUppercaseText()) {
				textInput.value = textInput.value.toUpperCase();
			}

			updateTextOnCup(textInput);
		}
	});

	const updateTextOnCup = (textInput) => {
		const textLength = textInput.value.length;
		const engravingMaxLength = 5;

		textInput.value = textInput.value.replace(/[^a-zA-Z0-9 ]/gm, '');

		textInput.value = textInput.value.replace(/[^a-zA-Z0-9 ]/gm, '');

		const isFirstCharUppercase = /^[A-Z]/.test(textInput.value);

		const formattedInput = shouldUseUppercaseText()
			? textInput.value.toUpperCase()
			: isFirstCharUppercase
				? textInput.value.charAt(0) + textInput.value.slice(1).toLowerCase()
				: textInput.value.toLowerCase();

		if (shouldUseUppercaseText()) {
			textInput.value = formattedInput;
		}

		cloneElement.innerHTML = formattedInput;

		cloneElement.style.fontFamily = window.getComputedStyle(engravingText).fontFamily;

		let fontMultiplier = 1.4;
		let fontMinifier = 0.6;

		if (window.innerWidth < 1280 || window.innerHeight < 800) {
			fontMultiplier = 1.3;
			fontMinifier = 0.5;
		}

		if (
			cloneElement.clientWidth < engravingText.clientWidth &&
			engravingBox.classList.contains('engraving-image__box--modernline') &&
			isFirstCharUppercase
		) {
			engravingText.style.fontSize = engravingText.clientHeight * fontMinifier + 'px';
		} else if (cloneElement.clientWidth > engravingText.clientWidth) {
			engravingText.style.fontSize = (engravingText.clientWidth / formattedInput.length) * fontMultiplier + 'px';
		} else {
			engravingText.style.fontSize = window.getComputedStyle(cloneElement).fontSize;
		}

		if (textLength <= engravingMaxLength) {
			engravingText.innerHTML = formattedInput;
		}

		if (event.target && event.target.value?.toLowerCase() === 'names') {
			window.currentProductPersonalisation.multipleNames = true;
		} else {
			window.currentProductPersonalisation.multipleNames = false;
		}
	};

	document.querySelector('.product-engraving__overlay').addEventListener('click', () => {
		closeModal();
	});

	//Functions

	const zoom = (param) => {
		const currentZoom = currentProductPersonalisation.scale;
		const currentRotation = currentProductPersonalisation.rotation;
		let nextZoom;

		param === '+' ? (nextZoom = currentZoom + 0.1) : (nextZoom = currentZoom - 0.1);

		document.querySelector('#engraving-image__canvas').style.transform = `rotate(${currentRotation}deg) scale(${nextZoom.toFixed(2)})`;

		currentProductPersonalisation.scale = nextZoom;
	};

	function backToFirstStep() {
		const stepPanels = getStepPanels();

		getAllStepPanels().forEach((panel) => {
			panel.style.display = 'none';
		});

		if (stepPanels[0]) {
			stepPanels[0].style.display = 'flex';
		}
	}

	function backToFirstStepIfPhone() {
		function ifPhone(x) {
			if (x.matches) {
				backToFirstStep();
			} else {
				// Clear JS-set inline styles so CSS layout takes over on desktop
				getAllStepPanels().forEach((panel) => clearStepPanelDisplay(panel));
			}

			// Re-apply font size using current breakpoint values
			if (engravingText && engravingInput && engravingInput.value.length > 0) {
				updateTextOnCup(engravingInput);
			}
		}

		let x = window.matchMedia('screen and (max-width: 1280px), screen and (max-height: 800px)');

		ifPhone(x);

		x.addListener(ifPhone);
	}

	function clearInputFile(f) {
		if (f.value) {
			try {
				f.value = ''; //for IE11, latest Chrome/Firefox/Opera...
			} catch (err) {}
			if (f.value) {
				//for IE5 ~ IE10
				var form = document.createElement('form'),
					parentNode = f.parentNode,
					ref = f.nextSibling;
				form.appendChild(f);
				form.reset();
				parentNode.insertBefore(f, ref);
			}
		}

		const context = previewCanvas.getContext('2d');
		context.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
	}

	const updatePersonalisationInfoBox = (currentPersonalisation) => {
		document.querySelector('.personalisation-info').setAttribute('data-variant-id', currentPersonalisation.id);
		document.querySelector('.personalisation-info').setAttribute('data-variant-key', currentPersonalisation.key);
		removeEngravingButton.setAttribute('data-variant-id', currentPersonalisation.id);
		removeEngravingButton.setAttribute('data-variant-key', currentPersonalisation.key);
		personalisationInfo.style.display = 'block';
	};

	function removePersonalisationUi() {
		currentProductPersonalisation.enabled = false;
		engravingText.innerHTML = '';
		engravingButton.textContent = 'Add to Cart';
		engravingButton.disabled = true;
		personalisationInfoContainer.style.display = 'none';
		document.querySelector('.trigger-personalisation').innerHTML = document.querySelector('.trigger-personalisation').dataset.initialLabel;
		engravingInput.value = '';
		engravingButton.removeAttribute('data-index');
		window.currentProductPersonalisation.personalisationAdded = false;

		clearInputFile(imageInput);
		backToFirstStepIfPhone();
	}

	const getCartData = async () => {
		const response = await fetch('/cart.js');
		const data = await response.json();

		return data;
	};

	const getProductData = async (productHandle) => {
		try {
			const response = await fetch(`/products/${productHandle}.js`, {
				method: 'GET',
			});

			return response.json();
		} catch (error) {
			console.error(error);
		}
	};

	const loadCorsImage = (src) =>
		new Promise((resolve, reject) => {
			const img = new Image();

			img.crossOrigin = 'anonymous';
			img.onload = () => resolve(img);
			img.onerror = reject;
			img.src = src;
		});

	const drawTextWithLetterSpacing = (ctx, text, centerX, centerY, letterSpacing) => {
		const spacing = Number.isFinite(letterSpacing) ? letterSpacing : 0;

		if (!spacing) {
			ctx.textAlign = 'center';
			ctx.fillText(text, centerX, centerY);
			return;
		}

		const chars = [...text];
		const totalWidth = chars.reduce((width, char, index) => {
			return width + ctx.measureText(char).width + (index < chars.length - 1 ? spacing : 0);
		}, 0);

		ctx.textAlign = 'left';

		let currentX = centerX - totalWidth / 2;

		for (const char of chars) {
			ctx.fillText(char, currentX, centerY);
			currentX += ctx.measureText(char).width + spacing;
		}
	};

	// html2canvas can't render background-clip:text accurately — rasterize metallic text first
	const rasterizeEngravingText = async (textEl) => {
		const text = textEl.textContent?.trim();
		const style = window.getComputedStyle(textEl);

		if (!text || style.display === 'none' || style.visibility === 'hidden') return null;

		const width = Math.max(1, textEl.offsetWidth);
		const height = Math.max(1, textEl.offsetHeight);
		const scale = 2;
		const canvas = document.createElement('canvas');
		const ctx = canvas.getContext('2d');
		const letterSpacing =
			style.letterSpacing === 'normal' ? 0 : Number.parseFloat(style.letterSpacing) || 0;

		canvas.width = Math.ceil(width * scale);
		canvas.height = Math.ceil(height * scale);
		ctx.scale(scale, scale);
		ctx.font = `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
		ctx.textBaseline = 'middle';
		ctx.fillStyle = '#000';

		drawTextWithLetterSpacing(ctx, text, width / 2, height / 2, letterSpacing);

		const metalTexture = await loadCorsImage(METAL_TEXTURE_URL);

		ctx.globalCompositeOperation = 'source-in';
		ctx.drawImage(metalTexture, 0, 0, width, height);

		const img = document.createElement('img');

		img.src = canvas.toDataURL('image/png');
		img.alt = '';
		img.className = 'engraving-image__text-capture';
		img.style.position = 'absolute';
		img.style.left = `${textEl.offsetLeft}px`;
		img.style.top = `${textEl.offsetTop}px`;
		img.style.width = `${width}px`;
		img.style.height = `${height}px`;
		img.style.objectFit = 'contain';
		img.style.pointerEvents = 'none';
		img.style.zIndex = '2';
		// Cobranded Logo & Text rotates the text node itself (270deg)
		img.style.transform = style.transform;
		img.style.transformOrigin = style.transformOrigin;

		return img;
	};

	// Swap CSS backgrounds / clipped text for real images so the mockup matches the preview
	const prepareMockupCaptureDom = async () => {
		const cup = canvasTopl.querySelector('.cup');
		const textEl = canvasTopl.querySelector('.engraving-image__text');
		const cleanupNodes = [];
		const restoreStyles = [];

		if (cup) {
			const backgroundImage = window.getComputedStyle(cup).backgroundImage;
			const backgroundUrlMatch = backgroundImage.match(/url\((['"]?)(.*?)\1\)/);

			if (backgroundUrlMatch?.[2]) {
				const cupImg = await loadCorsImage(backgroundUrlMatch[2]);

				cupImg.className = 'cup cup--capture-img';
				cupImg.alt = '';
				cupImg.style.width = '100%';
				cupImg.style.height = '100%';
				cupImg.style.objectFit = 'contain';
				cupImg.style.display = 'block';

				restoreStyles.push(() => {
					cup.style.display = '';
				});

				cup.style.display = 'none';
				cup.parentNode.insertBefore(cupImg, cup);
				cleanupNodes.push(cupImg);
			}
		}

		if (textEl) {
			const textImg = await rasterizeEngravingText(textEl);

			if (textImg) {
				restoreStyles.push(() => {
					textEl.style.visibility = '';
				});

				textEl.style.visibility = 'hidden';
				textEl.parentNode.appendChild(textImg);
				cleanupNodes.push(textImg);
			}
		}

		return () => {
			cleanupNodes.forEach((node) => node.remove());
			restoreStyles.forEach((restore) => restore());
		};
	};

	function dataURItoBlob(dataURI) {
		let byteString;

		if (dataURI.split(',')[0].indexOf('base64') >= 0) byteString = atob(dataURI.split(',')[1]);
		else byteString = unescape(dataURI.split(',')[1]);

		let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
		let ia = new Uint8Array(byteString.length);

		for (let i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}

		return new Blob([ia], { type: mimeString });
	}
});

window.addEventListener('load', () => {
	document.dispatchEvent(new CustomEvent('check-personalization-inventory'), { bubbles: true });
});
